import { Haptics, ImpactStyle, NotificationType } from '@capacitor/haptics';
import { esApp } from './plataforma';

/**
 * Vibraciones suaves del iPhone (Taptic Engine) en los momentos clave: al
 * guardar, si algo falla o al confirmar un borrado. Como pide la guía de
 * Apple, son discretas, acompañan a lo que se ve (nunca lo sustituyen) y se
 * pueden apagar en Configuración → Perfil. Si el usuario quita la vibración
 * del sistema, iOS las anula solo. En la web no hacen nada.
 */

const CLAVE = 'rzcentral.vibraciones';

/** Encendidas salvo que el usuario las apague. Se copia aquí desde la cuenta (src/utils/preferencias.ts). */
export function vibracionesActivas(): boolean {
  try {
    return localStorage.getItem(CLAVE) !== 'no';
  } catch {
    return true;
  }
}

export function guardarVibraciones(activas: boolean): void {
  try {
    localStorage.setItem(CLAVE, activas ? 'si' : 'no');
  } catch { /* sin almacenamiento: se quedan como estaban */ }
}

function siProcede(vibrar: () => Promise<void>) {
  if (!esApp || !vibracionesActivas()) return;
  vibrar().catch(() => { /* un iPad sin Taptic Engine: nada */ });
}

export const vibrar = {
  /** Algo se ha guardado bien: una transacción, un gasto compartido… */
  exito: () => siProcede(() => Haptics.notification({ type: NotificationType.Success })),
  /** No se ha podido hacer lo que se pedía. */
  error: () => siProcede(() => Haptics.notification({ type: NotificationType.Error })),
  /** Se confirma una acción destructiva, como borrar. */
  fuerte: () => siProcede(() => Haptics.impact({ style: ImpactStyle.Medium })),
  /** Un toque ligero: apuntar o tachar algo de una lista. */
  suave: () => siProcede(() => Haptics.impact({ style: ImpactStyle.Light })),
};
